<template>
  <Pull :onPull="pull" ref="pull">
  <div class="main-content">
    <div class="head-navigate">
      <a-icon
        type="left"
        :style="{ fontSize: '20px', color: '#333' }"
        @click="backPage"
      />
      <span>抄表列表</span>
    </div>
    <!-- 顶部状态菜单选择部分 -->
    <div class="menu-select">
      <div @click="dateShow = true">
        <span>{{ requestData.meterReadingMonthDate }}</span>
        <a-icon type="down" :style="{ fontSize: '12px' }" />
      </div>
      <!--<div @click="roomShow=true">
				<span>{{selectRoomName}}</span>
				<a-icon type="down" />
			</div>-->
      <div @click="tableShow = true">
        <span>{{ selectTableName }}</span>
        <a-icon type="down" :style="{ fontSize: '12px' }" />
      </div>
      <div @click="statusShow = true">
        <span>{{ selectStatusName }}</span>
        <a-icon type="down" :style="{ fontSize: '12px' }" />
      </div>
    </div>
    <!-- 抄表进度部分 -->
    <div class="copy-process">
      <span>抄表进度</span>
      <a-progress :percent="dataObj.perRead" :show-info="false" />
      <div>
        <span>{{ dataObj.meterRead }}/</span>
        <span>{{ dataObj.total }}</span>
      </div>
    </div>
    <!-- 抄表内容部分 -->
    <div class="list-content" v-if="resdata.length > 0">
      <div class="content-all">
        <div
          class="content-part"
          @click="navigatePage(item)"
          v-for="(item, index) in resdata"
          :key="index"
        >
          <img :src="item.img" mode="" />
          <div>
            <div>
              <span>{{ item.instrumentationName }}</span>
              <span
                :style="{
                  color: item.isMeterReading == 0 ? '#46CC5E' : '#FE5208',
                }"
                >{{ item.isMeterReading == 0 ? "已抄表" : "未抄表" }}</span
              >
            </div>
            <span>{{ item.area }}</span>
            <span>上次抄表时间：{{ item.lastDate }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="no-data" v-else>
      <img src="../assets/propertyImg/no-data.png" alt="" />
      <span>暂无房屋数据列表</span>
    </div>
    <!-- <div class="loadMore" v-if="isData" @click="gainMore">
      加载更多
    </div>
    <div class="noMore" v-else>
      没有更多了。。。
    </div> -->
    <!-- 日历选择 -->
    <van-action-sheet v-model="dateShow">
      <van-datetime-picker
        v-model="currentDate"
        type="year-month"
        title="选择年月"
        :min-date="minDate"
        :max-date="maxDate"
        @cancel="dateShow = false"
        @confirm="dateConfirm"
        :formatter="formatter"
      />
    </van-action-sheet>
    <!-- 仪表种类选择 -->
    <van-action-sheet v-model="tableShow">
      <van-picker
        title="仪表种类"
        show-toolbar
        value-key="name"
        :columns="tableActions"
        @confirm="tableSelect"
        @cancel="tableShow = false"
      />
    </van-action-sheet>
    <!-- 仪表状态选择 -->
    <van-action-sheet v-model="statusShow">
      <van-picker
        title="仪表状态"
        show-toolbar
        value-key="name"
        :columns="statusActions"
        @confirm="statusSelect"
        @cancel="statusShow = false"
      />
    </van-action-sheet>
  </div>
  </Pull>
</template>
<script>
import { getCopyList } from "../axios/property";
import Pull from '../commonComponents/PullRefresh'
export default {
  components: {
    Pull
  },
  data() {
    return {
      dataObj: {}, // 页面总数据
      requestData: {
        // 请求数据
        meterReadingMonthDate: "",
        instrumentationType: null,
        isMeterReading: null,
      },
      resdata: [],
      selectRoomName: "房屋种类", // 房屋种类名称
      selectTableName: "仪表种类", // 仪表种类名称
      selectStatusName: "仪表状态", // 仪表状态名称
      roomActions: [
        // 房屋类型
        { name: "房间", value: 1 },
        { name: "楼层", value: 2 },
        { name: "楼栋", value: 3 },
        { name: "区域", value: 4 },
      ],
      tableActions: [
        // 仪表种类
        { name: "全部", value: null },
        { name: "普通水表", value: 1 },
        { name: "普通电表", value: 2 },
      ],
      statusActions: [
        // 仪表状态
        { name: "全部", value: null },
        { name: "已抄表", value: 0 },
        { name: "未抄表", value: 1 },
      ],
      dateShow: false, // 日期选择
      tableShow: false, // 仪表类型选择
      statusShow: false, // 仪表状态选择
      minDate: new Date(2010, 0, 1),
      maxDate: new Date(2030, 10, 1),
      currentDate: new Date(),
      companyId: "", // 公司ID
      isData: true,
      currentPage: 1,
      currentPageSize: 30
    };
  },
  created() {
    this.companyId = this.$store.state.initialData.companyId;
    let today = new Date();
    let todayYear = today.getFullYear();
    let todayMonth = today.getMonth() + 1;
    if (todayMonth < 10) {
      todayMonth = "0" + todayMonth;
    }
    console.log(todayYear, todayMonth);
    this.requestData.meterReadingMonthDate = todayYear + "-" + todayMonth;
    this.getData();
  },
  methods: {
    pull(num) { // 上拉刷新
        console.log('pull回调List');
        this.gainMore()
        // setTimeout(() => {
        //   this.num = num;
        //   if (this.history_list.length >= this.pk_list_data.others_family_list.length) {
        //     console.log('完了');
        //     this.$refs.pull.$emit('loadOver') // 加载完毕
        //   } else {
        //     console.log(666)
        //     this.$refs.pull.$emit('loadEnd') // 加载完毕
        //   }

        // }, 2000)
    },
    gainMore(){ // 加载更多数据列表
      this.currentPage += 1
      this.getData()
    },
    getData() {
      // 获取列表数据
      let that = this;
      let data = {
        companyId: this.companyId,
        currentPage: this.currentPage,
        currentPageSize: this.currentPageSize,
        ...this.requestData,
      };
      getCopyList(data).then((res) => {
        console.log(res);
        let responseData = res.data;
        let responseDataArr = res.data.data.record
        if (responseData.code == 0) {
          responseData.data.perRead = (
            (responseData.data.meterRead * 100) /
            responseData.data.total
          ).toFixed(0);
          responseData.data.perRead = parseInt(responseData.data.perRead);
          for (let i = 0; i < responseDataArr.length; i++) {
            if (responseDataArr[i].lastDate) {
              responseDataArr[i].lastDate = new Date(
                responseDataArr[i].lastDate
              ).toLocaleString("chinese", { hour12: false });
            }
            if (responseDataArr[i].instrumentationType == 1) {
              if (responseDataArr[i].isShare == 0) {
                responseDataArr[
                  i
                ].img = require("../assets/propertyImg/shareImg2.png");
              } else {
                responseDataArr[
                  i
                ].img = require("../assets/propertyImg/roomImg2.png");
              }
            } else {
              if (responseDataArr[i].isShare == 0) {
                responseDataArr[
                  i
                ].img = require("../assets/propertyImg/shareImg1.png");
              } else {
                responseDataArr[
                  i
                ].img = require("../assets/propertyImg/roomImg1.png");
              }
            }
          }
        }
        if (responseDataArr.length == 0) {
            that.$refs.pull.$emit('loadOver') // 加载完毕，无数据了
            that.isData = false;
          } else {
            that.$refs.pull.$emit('loadEnd') // 加载完毕，可能还有下一波数据
            for (let i = 0; i < responseDataArr.length; i++) {
              that.resdata.push(responseDataArr[i]);
            }
            that.isData = true;
          }
        that.dataObj = responseData.data;
      });
    },
    formatter(type, val) {
      // 日期选择框格式
      if (type === "year") {
        return `${val}年`;
      } else if (type === "month") {
        return `${val}月`;
      }
      return val;
    },
    dateConfirm(value) {
      // 更改日期
      this.dateShow = false;
      let valueYear = value.getFullYear();
      let valueMonth = value.getMonth() + 1;
      if (valueMonth < 10) {
        valueMonth = "0" + valueMonth;
      }
      this.requestData.meterReadingMonthDate = valueYear + "-" + valueMonth;
      this.resdata = []
      this.getData();
    },
    tableSelect(value) {
      // 更改仪表类型
      this.selectTableName = value.name;
      this.requestData.instrumentationType = value.value;
      this.tableShow = false;
      this.resdata = []
      this.getData();
    },
    statusSelect(value) {
      // 更改仪表状态
      this.selectStatusName = value.name;
      this.requestData.isMeterReading = value.value;
      this.statusShow = false;
      this.resdata = []
      this.getData();
    },
    backPage() {
      // 回退到首页
      this.$router.push("/property-index");
    },
    navigatePage(item) {
      // 跳转页面
      console.log(item);
      this.$router.push({
        name: "CopyDetal",
        params: {
          obj: item,
        },
      });
    },
  },
};
</script>
<style scoped>
.main-content {
  background-color: #f9f9f9;
  margin-bottom: 0.3rem;
}
.head-navigate {
  display: flex;
  align-items: center;
  background-color: white;
  padding: 0.2rem 0.3rem;
}
.head-navigate span {
  font-size: 17px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 700;
  color: #333333;
  margin: auto;
}
/* 状态菜单筛选部分 */
.menu-select {
  display: flex;
  justify-content: space-around;
  padding: 0.3rem 0;
}

.menu-select > div {
  display: flex;
  align-items: center;
}
.menu-select > div /deep/.anticon-down {
  margin-top: 2px;
}
.menu-select > div span {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #939496;
  margin-right: 0.1rem;
}
.copy-process {
  display: flex;
  align-items: center;
  justify-content: space-around;
  width: 95%;
  padding: 0.4rem 0;
  margin: 0 auto;
  background-color: white;
  box-shadow: 0px 2px 8px 0px #ccd0d4;
  border-radius: 10px;
}

.copy-process /deep/.ant-progress-line {
  width: 5rem;
}

.copy-process > div {
  margin-top: 0.05rem;
}
.copy-process > div span:nth-child(1) {
  color: #1484ff;
}
.main-content /deep/.van-picker__toolbar {
  border-bottom: 1px solid #eeeeee;
}
/* 抄表内容部分 */
.list-content {
  padding: 0.3rem;
}
.list-content .content-all {
  background-color: white;
  padding: 0.3rem;
  border-radius: 8px;
}
.list-content .content-part {
  display: flex;
  align-items: center;
  border-bottom: 1px solid #f3f3f3;
  padding-bottom: 0.3rem;
  margin-bottom: 0.3rem;
}

.content-part img {
  /* width: 2rem;
  height: 1.5rem; */
  width: 65px;
  height: 64px;
}

.content-part > div {
  display: flex;
  flex-direction: column;
  margin-left: 0.3rem;
  width: 100%;
}

.content-part > div > div {
  margin-bottom: 0.1rem;
  display: flex;
}

.content-part > div > div span:nth-child(1) {
  margin-right: auto;
  font-size: 16px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 700;
  display: inline-block;
  width: 80%;
  color: #333333;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.content-part > div > div span:nth-child(2) {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
}

.content-part > div > span {
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #999;
  margin-bottom: 0.1rem;
}
.no-data {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding-top: 0.3rem;
}
.no-data img {
  width: 5rem;
  height: 5rem;
  margin-bottom: 0.5rem;
}
.no-data span {
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #999999;
  font-size: 28rpx !important;
}
/* 加载更多按钮样式 */
.loadMore {
  width: 50%;
  border-radius: 10px;
  margin: 0 auto;
  background-color: #1584ff;
  color: white;
  text-align: center;
  padding: 0.2rem 0;
  margin-top: 0.5rem;
}
.noMore {
  width: 50%;
  margin: 0 auto;
  color: #ccc;
  text-align: center;
  padding: 0.03rem 0;
  margin-top: 0.5rem;
}
</style>
